export default {
  // General UI elements
  save: "Save",
  saving: "Saving",
  cancel: "Cancel",
  edit: "edit",
  delete: "Delete",
  profile: "Profile",
  settings: "Settings",
  logout: "Log Out",
  language: "Language",
  loading: "Loading",
  submit: "Submit",
  search: "Search...",
  back: "Back",
  next: "Next",
  previous: "Previous",
  continue: "Continue",
  done: "Done",
  error: "Error",
  success: "Success",
  warning: "Warning",
  info: "Information",
  close: "Close",
  open: "Open",
  yes: "Yes",
  no: "No",
  ok: "OK",
   
  // Authentication
  auth: {
    signIn: "Sign In",
    signUp: "Sign Up",
    signOut: "Sign Out",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    sendResetLink: "Send Reset Link",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    or: "Or",
    continueWith: "Continue with",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    twitter: "Twitter",
    passwordRequirements: "Password must be at least 8 characters",
    passwordMatch: "Passwords must match",
    emailInvalid: "Please enter a valid email address"
  },
  
  // Profile specific
  username: "Username",
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  joinDate: "Join Date",
  streak: "Streak",
  xp: "XP",
  plan: "Plan",
  free: "Free",
  pro: "Pro",
  premium: "Premium",
  referralCode: "Referral Code",
  share: "Share",
  copy: "Copy",
  copied: "Copied!",
  contactUs: "Contact Us",
  termsOfService: "Terms of Service",
  privacyPolicy: "Privacy Policy",
  accountSettings: "Account Settings",
  changePassword: "Change Password",
  deleteAccount: "Delete Account",
  deleteAccountConfirm: "Are you sure you want to delete your account? This action cannot be undone.",
  updateProfile: "Update Profile",
  profileUpdated: "Profile updated successfully",
  shareTitle: "Check out Cookr!",
  shareText: "Join me on Cookr, a study app designed for students aged 12 and above!",
  shareFallbackMessage: "Sharing is not supported in this browser. Please copy the link manually.",
  saving: "Saving...",
  enterUsername: "Enter username",
  cancel: "Cancel",
  memberSince: "Member since",
  streak: "Streak",
  xp: "XP",
  pro: "Pro",
  recentActivity: "Recent Activity",
  noSetsYet: "No Sets Yet :(",
  upgradeToPro: "Upgrade to Pro",
  settings: "Settings",
  shareWithAFriend: "Share with a Friend",
  contactTheTeam: "Contact The Team",
  termsAndConditions: "Terms and Conditions",
  editUsername: "Edit Username:",
  logOut: "Log Out",
  usernameError1: "Username cannot be empty",
  usernameError2: "Please enter a different or new username",
  usernameError3: "Username cannot contain spaces",
  usernameError4: "Username cannot contain capital letters",
  usernameError5: "Username cannot contain special characters",
  usernameError6: "Username must be between 4 and 18 characters",
  usernameError7: "Username contains inappropriate content",
  usernameError8: "This username is already taken",
  clickOrDragAndDrop: "Click or Drag & Drop to Upload",
  confirm: "Confirm",
  retake: "Retake",

  // Bottom Nav
  profile: "Profile",
  home: "Home",
  library: "My Library",
  saved: "Saved",
  rankings: "Rankings",
  
  // Feature
  backToLibrary: "Back to Library",
  exploreSets: "Explore Sets",
  communitySets: "Community Sets",
  mySets: "My Sets",
  alreadyAdded: "Already Added",
  addToLibrary: "Add to Library",
  loading: "Loading...",
  loadMoreSets: "Load More Sets",
  by: "By",
  makePublic: "Make Public",
  subscriptionRequired: "Subscription Required",
  subscriptionRequiredMessage: "You can only have 10 sets at once in the library. Upgrade to premium for unlimited sets!",

  // My Library
  deleteSet: "Delete Set",
  deleteSetConfirmation: "Are you sure you want to delete this set?",
  yesDelete: "Yes, Delete",
  collections: "Public Sets",
  myLibrary: "My Library",
  outOf10Sets: "out of 10 sets added.",
  switchBackToPro: "Switch back to Pro",
  upgradeToPro: "Upgrade to Pro",
  outOf10OnFree: "out of 10 on free.",
  letMeCook: "Let me cook",
  selectMode: "Select Mode",
  multipleChoice: "Multiple Choice",
  flashcards: "Flashcards",
  freeResponse: "Free Response",
  proOnly: "Pro Only",
  leaderboard: "Leaderboard",
  favorites: "Favorites",
  profile: "Profile",
  reportBugs: "Report Bugs",

  // Question Card
  correctMessage: "Correct! You Cooked.",
  typeYourAnswer: "Type your answer here...",
  submitAnswer: "Submit Answer",
  responseCannotBeBlank: "Response cannot be blank",
  noAnswerAvailable: "No answer available",
  answerGuideline: "Answer Guideline",
  pleaseSubmitAnswerFirst: "Please submit your answer first",
  revealAnswer: "Reveal Answer",
  hideAnswer: "Hide Answer",
  gradingInProgress: "Grading In Progress...",
  grading: "Grading",
  answerGuidelines: "Answer Guidelines",
  finalScore: "Final Score:",
  evaluateAnswer: "Evaluate Answer",
  


  // Saved
  favorites: "Favorites",
  searchQuestions: "Search questions...",
  noSavedQuestions: "No saved questions yet.",

  // Scroller
  loadingMoreQuestions: "Loading More Questions",

  // New Prompt
  deleteSet: "Delete Set",
  deleteSetConfirmation: "Are you sure you want to delete this set?",
  yesDelete: "Yes, Delete",
  cancel: "Cancel",
  setLimitReached: "Set Limit Reached",
  setLimitError: "You can only have 10 sets at once in the library. Upgrade to premium for unlimited sets!",
  close: "Close",
  uploadNotes: "Upload Notes",
  general: "General",
  title: "Title",
  setTitleMessage: "Set a title for your AI generated Cookr questions, so it's easy to access later.",
  titleError1: "Title cannot be blank",
  titleError2: "Title contains inappropriate content",
  content: "Content",
  setContentMessage: "Copy and paste your notes, lectures or any other textual content.",
  contentError1: "Content cannot be blank",
  contentError2: "Content contains inappropriate content",
  subject: "Subject",
  setSubjectMessage: "What subject or topic is this content about?",
  subjectError1: "Subject cannot be blank",
  subjectError2: "Subject contains inappropriate content",

  // Payment Confirmation
  returnToProfile: "Return to Profile",

  // Plans
  confirmSwitch: "Confirm Switch to Free Plan",
  confirmSwitchMessage: "Are you sure you want to switch to the Free plan? You will lose access to premium features.",
  buttonConfirm: "Confirm Switch",
  processing: "Processing...",
  unlimitedScrolling: "Unlimited Scrolling",
  unlimitedSubjects: "Unlimited Subjects",
  aiTutorBot: "AI Tutor Bot",
  newFeatureAccess: "New Feature Access",
  saveScrolls: "Save Scrolls",
  infiniteNoteUploads: "Infinite Note Uploads",
  answerExplanations: "Answer Explanations",
  shareScrolls: "Share Scrolls",
  everythingInStandard: "Everything in Standard",
  current: "Current",
  switchOver: "Switch Over",
  forever: "/forever",
  monthly: "/month",
  yearly: "/year",

  // Leaderboard
  leaderboard: "Leaderboard",

  // Home.js
  pickASubject: "Pick a subject to get started with your session!",

  // scrollerLoader
  generatingContent: "Generating Content...",

  // Dropdown
  choose: "Choose",
  titleTooLong: "Title cannot contain more than 100 characters",

}
